export default __webpack_public_path__ + "static/speechbubbles2-c40e16d30c326f44eda94c8db09df2fe.png";